import { createSelector } from 'reselect'

const getLibraries = state => state.libraries
const getLessons = state => state.lessons

const AddLessonsMetricsSelector = createSelector(
	[getLibraries, getLessons],
	(libraries, lessonsList) => {
		const entityIds = libraries.find_lessons.selected_lessons
		const lessons = [], bundles = []

		entityIds.filter(function(id) {
			return lessonsList[id].library_object_type === '1'
		}).map(function(id) {
			lessons.push(lessonsList[id].data.entityUID)
		})

		entityIds.filter(function(id) {
			return lessonsList[id].library_object_type === '3'
		}).map(function(id) {
			bundles[id] = {}
			bundles[id].UID = lessonsList[id].data.entityUID
			bundles[id].totalPresentations = lessonsList[id].data.totalPresentations
		})

		return {
			lessons,
			bundles,
			libraryType: libraries.current.settings.entity_type,
		}
	}
)

export default AddLessonsMetricsSelector
